<div class="profile-page" data-testid="profile-page">
  <header class="profile-header" data-testid="profile-header">
    <h1 class="profile-title" data-testid="profile-title">My Profile</h1>

    @if (isProfileLoading()) {
      <p-skeleton
        styleClass="profile-skeleton profile-skeleton-user"
        width="12rem"
        height="1.5rem"
        data-testid="profile-user-name-skeleton">
      </p-skeleton>
    } @else {
      <p class="profile-user" data-testid="profile-user-name">{{ profile().userName }}</p>
    }
  </header>

  <section class="active-role-section" aria-labelledby="active-role-heading" data-testid="profile-active-role-section">
    <h2 id="active-role-heading" class="active-role-heading">Active Role</h2>

    <div class="role-options" role="radiogroup" aria-labelledby="active-role-heading" data-testid="profile-role-options">
      @for (role of roles; track role.value) {
        <label
          class="role-option"
          [class.active]="activeRole() === role.value"
          [class.disabled]="isRoleDisabled(role.value)"
          [attr.data-testid]="'profile-role-option-' + role.value">

          <p-radioButton
            name="activeRole"
            [value]="role.value"
            [ngModel]="selectedRole()"
            (ngModelChange)="onRoleSelected($event)"
            [disabled]="isRoleDisabled(role.value)"
            [inputId]="'active-role-' + role.value"
            [attr.data-testid]="'profile-radio-' + role.value">
          </p-radioButton>

          <span class="role-label">{{ role.label }}</span>

          @if (activeRole() === role.value) {
            <span class="active-role-badge" data-testid="profile-active-role-badge">Active</span>
          }
        </label>
      }
    </div>

    @if (isSwitching()) {
      <div class="switching-state" data-testid="profile-switching-state">
        <p-progressSpinner
          styleClass="switching-spinner"
          strokeWidth="4"
          animationDuration=".8s">
        </p-progressSpinner>
        <span>Switching role...</span>
      </div>
    }
  </section>
</div>